import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResizableDirective } from './resizable/resizable.directive';
import { DisableControlFormDirective } from './disable-control-form/disable-control-form.directive';
import { MasksDirective } from './masks/masks.directive';
import { HeightDirective } from './height/height.directive';
import { DateMasksDirective } from './masks/dateMasks.directive';
import { ValidatorsViewErrorsDirective } from './validators-view-errors/validators-view-errors.directive';
import { CurrencyDirective } from './currency-input/currency.directive';
import { NoRightClickDirective } from './no-rigth-click/no-rigth-click.directive';
import { DisableAutocompleteDirective } from './disable-autocomplete/disable-autocomplete.directive';
import { CurrencyFormatterDirective } from './CurrencyFormatter/currency-formatter.directive';
import { MultiselectResetSearchDirective } from './multiselect-reset-search/multiselect-reset-search.directive';


@NgModule({
  imports: [CommonModule],
  declarations: [
    ResizableDirective,
    DisableControlFormDirective,
    MasksDirective,
    DateMasksDirective,
    HeightDirective,
    ValidatorsViewErrorsDirective,
    NoRightClickDirective,
    CurrencyDirective,
    DisableAutocompleteDirective,
    CurrencyFormatterDirective,
    MultiselectResetSearchDirective
  ],
  exports: [
    ResizableDirective,
    DisableControlFormDirective,
    MasksDirective,
    DateMasksDirective,
    HeightDirective,
    ValidatorsViewErrorsDirective,
    CurrencyDirective,
    NoRightClickDirective,
    DisableAutocompleteDirective,
    CurrencyFormatterDirective,
    MultiselectResetSearchDirective
  ],
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/app/directives/directives.module.ts